const database = [
    {
        path: '/dataBaseMain',
        name: 'dataBaseMain',
        redirect: '/dataBaseList',
        meta: { breadcrumb: '资料库' },
        component: () => import('@/views/database/DataBaseMain.vue'),
        children: [
            {
                path: '/dataBaseList',
                name: 'dataBaseList',
                meta: { breadcrumb: '课程列表' },
                component: () => import('@/views/database/pages/DatabaseList.vue')
            },
            {
                path: '/classDate',
                name: 'classDate',
                meta: { breadcrumb: '课程详情' },
                component: () => import('@/views/database/pages/classDate.vue')
            }
        ]
    }
]

export default database